import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute,Params,Router } from "@angular/router";
import { CommonService } from "../../_services/common.service";
import { CommonProjectDataService } from "../../_services/common-project-data.service";

@Component({
  selector: 'app-public-client-reset-password',
  templateUrl: './public-client-reset-password.component.html',
  styleUrls: ['./public-client-reset-password.component.css']
})
export class PublicClientResetPasswordComponent implements OnInit {
  userToken: any;
  isResetPassword: false;
  resetPasswordStatus: any;
  isResetPasswordError: boolean = false;
  resetPasswordError: any;
  public siteDetail:any={};
  public userDetails:any={};
  public loginLogo:string;

  constructor(
    private CommonService: CommonService,
    private CommonProjectDataService: CommonProjectDataService,
   private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.siteDetail = JSON.parse(localStorage.getItem('siteData')); 
    this.userDetails = (localStorage.getItem('userDetails')) ? JSON.parse(localStorage.getItem('userDetails')) : false;
    this.loginLogo=localStorage.getItem('loginLogo'); 
    this.userToken = this.route.snapshot.params['token'];
  };  
 
  resetPassword = function (password, confirmPassword) {   
    if (password == confirmPassword) {
      let attributeOptions = {
        token: this.userToken,
        password: password,
        confirm_password: confirmPassword
      };
      this.CommonService.apiService(
        "POST",
        "password/reset",
        attributeOptions
      ).subscribe(
        (response: any) => {
          if (response.status === true) {
            this.isResetPasswordError = false;
            this.isResetPassword = true;
            this.resetPasswordStatus = response.message;
            localStorage.setItem('resetPassword', 'true');
            
            setTimeout(() => {
              this.backToHome();
            }, 2000);
          }
        },
        err => {
          this.isResetPasswordError = true;
          this.resetPasswordError = err.error.message;
          console.log(err);
        }
      );
    }
    else {
      this.isResetPasswordError = true;
      this.isResetPassword = false;
      this.resetPasswordError = "Password and confirm password mismatch!";
    }
  };

  backToHome() {
    this.CommonProjectDataService.storeQuoteRequest(true);
    this.CommonProjectDataService.storeClientId(null);
    localStorage.removeItem('storeId');
    localStorage.removeItem('pfMainFilters');
    localStorage.setItem('create_new_quote', 'true');
    this.router.navigate(["/builder/quote/order"]);
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-public-quote/public-client-reset-password/public-client-reset-password.component.ts